export const ACTIONS = {
    SET_PROVIDER: "SET_PROVIDER",
    SET_WALLETS: "SET_WALLETS",
    SET_PENDINGTX: "SET_PENDINGTX",
    SET_CHAIN_ID: "SET_CHAIN_ID",
    SET_OPENSIGNAL_URL: "SET_OPENSIGNAL_URL",
    SET_OPENSIGNALTOKEN_URL: "SET_OPENSIGNALTOKEN_URL",
    SET_TOKEN_BALANCE: "SET_TOKEN_BALANCE",
    TOKEN_BALANCE_TRIGGER: "TOKEN_BALANCE_TRIGGER",
};
